var map = {
	"./proximasoft-bold-webfont.woff2": 93,
	"./proximasoft-regular-webfont.woff2": 97
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font ^\.\/.*\.woff2$
// module id = 35
// module chunks = d-game